<script lang="ts">
  import List from '$shared/molecules/List/List.svelte';
  import Title from '$shared/atoms/Title/Title.svelte';

  interface Props {
    name?: string;
    dataList?: any;
    onevent?: (payload: any) => void;
  }

  let { name = '', dataList = [], onevent }: Props = $props();
</script>

<div data-cy={name} class="list">
  {#each dataList as item}
    <div class="list-i">
      {#if item}
        {#if item['__title']}
          <div data-cy={`${item['__title']}-header`} class="title">
            <Title type="h3">{item['__title']}</Title>
          </div>
        {/if}
        <List problems={item.__problems || item.__meta?.problems} list={item} {onevent} />
        {#if Object.values(item).find((value) => value?.isRequired)}
          <div data-cy={`${name}-info`} class="info">
            * Information used to perform a verification from the primary source
          </div>
        {/if}
      {/if}
    </div>
  {:else}
    <div class="empty">No Data Found</div>
  {/each}
</div>

<style>
  .list {
    width: 100%;
  }
  .list-i:not(:last-child) {
    margin-bottom: 32px;
  }
  .title {
    margin-bottom: 20px;
  }
  .info {
    font-weight: 400;
    font-size: 11px;
    line-height: 18px;
    margin-top: 10px;
    color: var(--grey-medium);
  }
</style>
